import { Col, Descriptions, Table } from 'antd';
import React from 'react';
import { useSelector } from 'react-redux';
import { DataTable, TextAreaField } from 'components';
import { isEmpty } from 'lodash';
import { getFullDateTimeWithSeconds, printInfo } from 'utils/helpers';
import { currencyFormatter, percentageFormatter } from 'utils';
import dayjs from 'dayjs';
import styles from './basicInfo.module.scss';

const BasicInfo = () => {
  const apptrackDetails = useSelector(state => state.appTrack.apptrackDetails);
  const parseFlag = apptrackDetails?.variablesIndexed?.parseFlag;
  const jsonVariables = apptrackDetails?.variablesIndexed?.dapanesEpendysis
    ? JSON?.parse(apptrackDetails?.variablesIndexed?.dapanesEpendysis)
    : {};
  // console.log("apptrackDetails:",JSON.parse(apptrackDetails.variablesIndexed.dapanesEpendysis));
  // console.log("apptrackDetails:",apptrackDetails.localTaskVariables);
  const excelData = useSelector(
    state => state.appTrack?.apptrackDetails?.variablesIndexed?.dapanesEpendysis
  );
  const localTaskVariables = apptrackDetails?.localTaskVariables;
  const variablesIndexed =
    isEmpty(localTaskVariables) ||
    apptrackDetails.activeTaskName !== 'task.name.submit_application'
      ? apptrackDetails?.variablesIndexed
      : localTaskVariables;

  const columnsInvestmentTotalAmountTable = [
    {
      title: 'Χρηματοδοτικό Σχήμα Επιλέξιμου',
      dataIndex: 'title',
      key: 'title',
      align: 'left',
      width: 180,
    },
    // {
    //   title: 'Πηγή Χρηματοδότησης',
    //   dataIndex: 'budgetOwner',
    //   key: 'budgetOwner',
    //   align: 'center',
    //   width: 160,
    // },
    // {
    //   title: '% Συνεισφοράς',
    //   dataIndex: 'percentage',
    //   key: 'percentage',
    //   align: 'center',
    //   width: 120,
    // },
    {
      title: 'Ποσό (€)',
      dataIndex: 'amount',
      key: 'amount',
      align: 'right',
      width: 120,
    },
  ];

  const testSelectedDataTable = [
    {
      title: 'Βελτίωση της ενεργειακής απόδοσης επιχειρήσεων', //commercial loan
      budgetOwner: {},
      percentage: percentageFormatter(
        variablesIndexed?.commercialLoanPercentage * 100
      ),
      amount: currencyFormatter(variablesIndexed?.commercialLoan),
    },
    {
      title: 'Σύνολο', //totalbudget
      budgetOwner: {},
      percentage: '100,00%',
      amount: currencyFormatter(
        variablesIndexed?.totalEstimate +
          variablesIndexed?.commercialLoan +
          variablesIndexed?.loan
      ),
    },
  ];

  const testSelectedDataTableTotal = [
    {
      title: 'Επιδότηση', //totalEstimate
      percentage: variablesIndexed?.totalEstimatePercentage,
      SumTotalExpense: variablesIndexed?.totalEstimate,
    },
    {
      title: 'Ιδία συμμετοχή', //commercial loan
      percentage: variablesIndexed?.commercialLoanPercentage,
      SumTotalExpense: variablesIndexed?.commercialLoan,
    },
    {
      title: 'Τραπεζικός Δανεισμός', //loan
      percentage: variablesIndexed?.loanPercentage,
      SumTotalExpense: variablesIndexed?.loan,
    },
    {
      title: 'Σύνολο', //totalbudget
      percentage: '100,00%',
      SumTotalExpense: currencyFormatter(
        variablesIndexed?.totalEstimate +
          variablesIndexed?.commercialLoan +
          variablesIndexed?.loan
      ),
    },
  ];

  const testSelectedDataTableSchema = [
    {
      title: 'Επιλέξιμη Επένδυση', //totalEstimate
      SumTotalExpense: currencyFormatter(
        variablesIndexed?.totalEstimate +
          variablesIndexed?.commercialLoan +
          variablesIndexed?.loan
      ),
    },
    {
      title: 'Μη Επιλέξιμη Επένδυση', //commercial loan
      SumTotalExpense: 0,
    },
    {
      title: 'Σύνολο', //totalbudget
      SumTotalExpense: currencyFormatter(
        variablesIndexed?.totalEstimate +
          variablesIndexed?.commercialLoan +
          variablesIndexed?.loan
      ),
    },
  ];

  const columnsTotalBudget = [
    {
      title: 'Χρηματοδοτικό Σχήμα Συνόλου Επένδυσης',
      dataIndex: 'title',
      key: 'title',
      align: 'left',
      width: 200,
    },
    {
      title: '% Συνεισφοράς',
      dataIndex: 'percentage',
      key: 'percentage',
      align: 'center',
      width: 200,
    },
    {
      title: 'Ποσό (€)',
      dataIndex: 'SumTotalExpense',
      key: 'SumTotalExpense',
      align: 'right',
      width: 200,
    },
  ];

  const totalColumnsSchema = [
    {
      title: 'Συνολικό Χρηματοδοτικό Σχήμα',
      dataIndex: 'title',
      key: 'title',
      align: 'left',
      width: 126,
    },
    {
      title: 'Ύψος Επένδυσης €',
      dataIndex: 'SumTotalExpense',
      key: 'SumTotalExpense',
      align: 'right',
      width: 126,
    },
  ];

  const columnsBeneficial = [
    {
      title: 'Ονοματεπώνυμο',
      dataIndex: 'fullName',
      key: 'fullName',
      align: 'left',
      width: 126,
    },
    {
      title: 'Α.Φ.Μ',
      dataIndex: 'taxId',
      key: 'taxId',
      align: 'center',
      width: 126,
    },
    {
      title: 'Ημ. Γέννησης',
      dataIndex: 'birthDate',
      key: 'birthDate',
      align: 'left',
      width: 126,
      render: value => (value ? dayjs(value).format('DD/MM/YYYY') : ''),
    },
    {
      title: '% Συμμετοχής',
      dataIndex: 'participationPercentage',
      key: 'participationPercentage',
      align: 'left',
      width: 126,
    },
    {
      title: 'Ιδιότητα',
      dataIndex: 'role',
      key: 'role',
      align: 'left',
      width: 126,
    },
  ];

  const columnsPrograms = [
    {
      title: 'Επιλεγμένα Προγράμματα',
      dataIndex: 'title',
      key: 'title',
      align: 'left',
      width: 126,
      render: value => <span className={'badge-program'}>{value}</span>,
    },
    {
      title: '',
      dataIndex: 'fundingAmount',
      key: 'fundingAmount',
      align: 'center',
      width: 126,
      render: value => <span>{currencyFormatter(value)}</span>,
    },
  ];

  return (
    <div style={{marginBottom: 120}} className={styles.basicInfoWrapper}>
      <p className="mr-0 color-purple-1 text-bold font-size-24">
        Επενδυτικό Σχέδιο
      </p>
      <div style={{ display: 'flex' }} >
        <Descriptions
          // title="Βασικά Στοιχεία Επιχείρησης"
          bordered
          className="large-titles-purple-responsive investment-plan-details-table"
          style={{ width: '47%', marginRight: '6%' }}
          column={1}
        >
          <Descriptions.Item label="Ημερομηνία & Ώρα Υποβολής">
            {getFullDateTimeWithSeconds(variablesIndexed?.submissionDate)}
          </Descriptions.Item>
          <Descriptions.Item label="Αρ. ΓΕΜΗ">
            {printInfo(variablesIndexed?.abiGcrCode)}
          </Descriptions.Item>
          <Descriptions.Item label="Α.Φ.Μ. Εταιρείας">
            {printInfo(variablesIndexed?.legalVat)}
          </Descriptions.Item>
          <Descriptions.Item label="Επωνυμία Εταιρείας ">
            {printInfo(variablesIndexed?.companyName)}
          </Descriptions.Item>
          <Descriptions.Item label="Τηλέφωνο Επικοινωνίας">
            {printInfo(variablesIndexed?.legalPhoneMobile)}
          </Descriptions.Item>
          <Descriptions.Item label="Email Επικοινωνίας">
            {printInfo(variablesIndexed?.legalEmail)}
          </Descriptions.Item>
          <Descriptions.Item label="Τίτλος Επενδυτικού Σχεδίου">
            {printInfo(jsonVariables?.ependutikoSxedio?.titlos)}
          </Descriptions.Item>
          <Descriptions.Item label="Κ.Α.Δ. Επενδυτικού Σχεδίου">
            {printInfo(jsonVariables?.ependutikoSxedio?.kwdikosKad)}
          </Descriptions.Item>
          <Descriptions.Item label="Τόπος Εκτέλεσης Επενδυτικού Σχεδίου">
            {printInfo(jsonVariables?.ependutikoSxedio?.topos?.toUpperCase())}
          </Descriptions.Item>
          <Descriptions.Item label="Ημερομηνία Έναρξης">
            {printInfo(jsonVariables?.ependutikoSxedio?.enarksh)}
          </Descriptions.Item>
          <Descriptions.Item label="Ημερομηνία Ολοκλήρωσης">
            {printInfo(jsonVariables?.ependutikoSxedio?.oloklhrwsh)}
          </Descriptions.Item>
          <Descriptions.Item label="Πιστωτικό Ίδρυμα">
            {printInfo(variablesIndexed?.bnkBank)}
          </Descriptions.Item>
        </Descriptions>
        <div style={{ width: '47%' }}>
          <div className="basicInfoSubtitleWrapper">
            <span className="basicInfoSubtitle">Σύντομη Περιγραφή</span>
          </div>
          <TextAreaField
            className="basicInfoTextArea"
            disabled={true}
            value={jsonVariables?.ependutikoSxedio?.perigrafi}
          ></TextAreaField>
        </div>
      </div>
      <p className="mt-6 mr-0 color-purple-3 text-bold font-size-24">
        Στοιχεία Πραγματικών Δικαιούχων
      </p>
      <Col span={24}>
        <div>
          <Table
            scroll={{ x: true }}
            id="basicInfo-application-results-table"
            className={'table-purple'}
            columns={columnsBeneficial}
            dataSource={variablesIndexed?.beneficialOwners}
            rowKey="id"
            pagination={false}
          />
        </div>
      </Col>

      <Col span={24}>
        <p className="mt-6 mr-0 color-purple-3 text-bold font-size-24">
          Χρηματοδοτικό Σχήμα Επένδυσης
        </p>
        <div style={{ marginBottom: '2rem' }}>
          <Table
            scroll={{ x: true }}
            id="basicInfo-application-results-table"
            className={'table-purple'}
            columns={columnsPrograms}
            dataSource={variablesIndexed?.fundingPrograms}
            rowKey="id"
            pagination={false}
          />
        </div>

        <div>
          <DataTable
            scroll={{ x: true }}
            id="basicInfo-application-results-table"
            className={`${
              !isEmpty(excelData)
                ? 'table-with-totals-purple'
                : 'table-with-totals-purple table-no-data'
            }`}
            columns={columnsTotalBudget}
            dataSource={testSelectedDataTableTotal}
            rowKey="id"
            // pagination={{
            //   showSizeChanger: false,
            //   showTitle: false,
            // }}
            pagination={false}
          />
        </div>

        {/* <div>
          <DataTable
            scroll={{ x: true }}
            id="basicInfo-application-results-table"
            className={`${
              !isEmpty(excelData)
                ? 'table-with-totals-purple'
                : 'table-with-totals-purple table-no-data'
            }`}
            columns={totalColumnsSchema}
            dataSource={testSelectedDataTableSchema}
            rowKey="id"
            // pagination={{
            //   showSizeChanger: false,
            //   showTitle: false,
            // }}
            pagination={false}
          />
        </div> */}
      </Col>
      {false && (
        <>
          <Col span={24}>
            <div>
              <DataTable
                scroll={{ x: true }}
                id="basicInfo-application-results-table"
                className={`${
                  !isEmpty(excelData)
                    ? 'table-with-totals-purple'
                    : 'table-with-totals-purple table-no-data'
                }`}
                columns={columnsInvestmentTotalAmountTable}
                dataSource={testSelectedDataTable}
                rowKey="id"
                // pagination={{
                //   showSizeChanger: false,
                //   showTitle: false,
                // }}
                pagination={false}
              />
            </div>
          </Col>
        </>
      )}
    </div>
  );
};

export default BasicInfo;
